<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Respuesta</th>
                <th :class="StyleTh">Valoración</th>
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>
            <template slot="body">
                <tr v-for="(item,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{item.Respuesta}}</h6></td>
                    <td><p :class="StyleTd">{{item.Valoracion}}</p></td>
                    <td>
                        <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="item.IdConfigEncuestaRespuesta" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
                        </CBtnAccion>
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="4"></CSinRegistros>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave" :IdConfigEncuestaPregunta="IdConfigEncuestaPregunta"></Form>
			</template>
		</CModal>
    </div>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionEncuestaRespuesta';
import Form from '@/views/modulos/crm/encuesta/respuesta/Form.vue';
export default {
    name: 'ListaEncuestaRespuesta',
    props: ['sFiltros','pOrigen','IdConfigEncuestaPregunta','IdConfigEncuesta'],
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Respuestas',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Pregunta',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Formulario",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize:'lg'
            },
            oBtnSave:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
        async Lista(){
            this.ConfigList.ShowLoader=true;
            
            await this.$http.get('configEncuestaRespuestas/',{
                params:{
                    TxtBusqueda:this.Filtro.Nombre,
                    Pag:this.Filtro.Pagina,
                    Entrada:this.Filtro.Entrada,
                    IdConfigEncuestaPregunta:this.IdConfigEncuestaPregunta
                }
            }).then((res)=>{
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows=res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader=false;
            })
        },
        Eliminar(Id){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('configEncuestaRespuestas/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'preguntas',params:{'IdConfigEncuesta':this.IdConfigEncuesta}});
        },  
    },
    created() {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }
        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted() {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    },
}
</script>

<style>

</style>